export const TRIM_DECIMAL_ZEROS_REGEX = /\.0+$/;
export const DEFAULT_DECIMALS = 2;

export const trimDecimalZeros = (number?: string): string => {
  return `${number}`.replace(TRIM_DECIMAL_ZEROS_REGEX, '');
};

export const cleanDecimal = (number: number, decimals = DEFAULT_DECIMALS): string => {
  return trimDecimalZeros(number.toFixed(decimals));
};

export const semverToNum = (v: string): number => {
  const [major, minor, patch] = v.split('.').map(Number);
  return major * 1_000_000 + minor * 1_000 + patch;
};

export function numberWithCommas(x: string) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function numberWithCommasLean(value: string, decimal: number = 1) {
  const num = parseFloat(value);

  if (num >= 1_000_000_000) {
    const value = Number((num / 1_000_000_000).toFixed(decimal));
    return `${numberWithCommas(value.toString())}B`;
  } else if (num >= 1_000_000) {
    const value = Number((num / 1_000_000).toFixed(decimal));
    return `${numberWithCommas(value.toString())}M`;
  } else if (num >= 1_000) {
    const value = Number((num / 1_000).toFixed(decimal));
    return `${numberWithCommas(value.toString())}K`;
  } else {
    return numberWithCommas(Number(num.toFixed(decimal)).toString());
  }
}
